/**
 * © 2025 Indikin.online. All rights reserved.
 * Made with ❤️ by YalaCoder.
 *
 * Analytics Page View Tracker
 *
 * --- REWRITE SUMMARY (Lint Fix) ---
 * - UPDATED (Import Path): The import for `useAnalytics` has been updated
 * to point to the new hook file at `../hooks/useAnalytics`.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAnalytics } from '../hooks/useAnalytics'; // <-- UPDATED PATH

const AnalyticsTracker = () => {
  const location = useLocation();
  const { trackPageView, isInitialized } = useAnalytics();

  useEffect(() => {
    if (isInitialized) {
      trackPageView(location.pathname + location.search);
    }
  }, [location, isInitialized, trackPageView]);

  return null;
};

export default AnalyticsTracker;
